<template>
<div class="choose-search-type" v-show="searchDialogShow" v-cloak @click.stop="">
    <cloud-select @changeOption="callFatherChange" ref="cloudSelect" :widthVal="160" :selectOption="selectOption" :placeholder="selectValue"></cloud-select>
    <div class="search-type-des" :title="$t('language.popup.cloudExploerPopup.highSpeed')" v-if="desShow">{{$t('language.popup.cloudExploerPopup.highSpeed')}}</div>
    <div class="search-type-des" :title="$t('language.popup.cloudExploerPopup.takeMoreTime')" v-if="!desShow">{{$t('language.popup.cloudExploerPopup.takeMoreTime')}}</div>
    <div class="choose-all">
        <div class="choose-title" @click.stop="addAllCheck()">
            <div class="icon-util  icon-search-position" v-if="!desShow" :class="selectItemArr.length==quickClouds.length&&quickClouds.length>0?'check-small':'nocheck-small'"></div>
            <div class="icon-util  icon-search-position" v-if="desShow" :class="selectItemArr.length==normalClouds.length&&normalClouds.length>0?'check-small':'nocheck-small'"></div>
            <span>{{$t('language.popup.addCloudPopup.cloudName')}}</span>
        </div>
        <div class="choose-items" v-if="!desShow">
            <div class="choose-item" v-for="(cloud,index) in quickClouds" :key="index" :title="cloud.name" @click.stop="addThisCheck(cloud)">
                <div style="float:left;" class="icon-util  icon-search-position" :class="selectItemArr.includes(cloud)?'check-small ':'nocheck-small '"></div>
                <span style="float:left" class="choose-cloud" @click.stop="">{{cloud.name}}</span>
            </div>
        </div>
        <div class="choose-items" v-if="desShow">
            <div class="choose-item" v-for="(cloud,index) in normalClouds" :key="index" :title="cloud.name" @click.stop="addThisCheck(cloud)">
                <div style="float:left;" class="icon-util  icon-search-position" :class="selectItemArr.includes(cloud)?'check-small ':'nocheck-small '"></div>
                <span style="float:left" class="choose-cloud" @click.stop="">{{cloud.name}}</span>
            </div>
        </div>
    </div>
    <input type="text" @keydown="changeColor()" class="search-type-input" v-model="searchValue" :placeholder="$t('language.popup.cloudExploerPopup.enterKeyWord')" />
    <button class="searchSubmit" @click.stop="submitValue()">{{$t('language.cloudExploer.search')}}</button>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import cloudSelect from "@/components/common/select/cloud_select";
import cloudExploerUtils from '@/js/workspace/cloud_exploer_util.js';
export default {
    data: function () {
        return {
            searchDialogShow: false,
            selectOption: [{
                name: this.$t('language.popup.cloudExploerPopup.highSpeedSearch')
            }, {
                name: this.$t('language.popup.cloudExploerPopup.normalSearch')
            }],
            selectValue: this.$t('language.popup.cloudExploerPopup.highSpeedSearch'),
            desShow: true,
            clouds: [],
            quickClouds: [],
            normalClouds: [],
            checkSign: -1,
            selectItemArr: [],
            searchValue: '',
            resultArr: []
        };
    },
    components: {
        "cloud-select": cloudSelect
    },
    mounted() {//初始化云盘数据
        this.clouds = this.$store.getters.getUsersDrives;
        if (!this.clouds.length) {//如果没有云盘数据则请求后端接口
            this.clouds = this.Utils.getAllCloudsList(function (res) {});
			//console.log(this.clouds);
        }
    },
    watch: {
        clouds(newValue, oldValue) {//监听界面的云盘数据
            let that = this;
            $.each(newValue, function (index, item) {
                $.each(item.methods, function (mIndex, mItem) {//根据返回数据的methods分为快递查询和普通查询两类
                    if (mItem.search) {
                        that.quickClouds.push(item);
                        return false;
                    }
                    if (mIndex == item.methods.length - 1) {
                        if (!mItem.search) {
                            that.normalClouds.push(item);
                        }
                    }
                });
            });
        },
        resultArr(newValue, oldValue) {//监听查询结果
            let that=this;
            if (newValue.length) {//对查询结果进行排序
                if(this.$route.query.searchResult=='1111'){
                this.$parent.tableData = commonUtils.sortArr(newValue, this.$parent.upShow, this.$parent.index);
                }
                this.$store.commit("setCacheTableDatas", {
                    id: 1111 + 'search',
                    tableData: newValue
                });//提交查询结果数据
            }
        }
    },
    methods: {
        callFatherChange(value) {//组件改变值
            if (value.replace(/^\s+|\s+$/g, "")== this.$t('language.popup.cloudExploerPopup.normalSearch').replace(/^\s+|\s+$/g, "")) {
                this.desShow = false;
            } else {
                this.desShow = true;
            }
            this.selectItemArr = [];
        },
        check: function (i) {//
            return "check" + i;
        },
        addThisCheck(item) {//选中一项数据
            if (this.selectItemArr.includes(item)) {
                this.selectItemArr = this.selectItemArr.filter(
                    function (ele) {
                        return ele != item;
                    });
            } else {
                this.selectItemArr.push(item);
            }
        },
        addAllCheck() {//选中所有数据
            if (!this.desShow) {
                if (this.selectItemArr.length && this.selectItemArr.length == this.quickClouds.length) {
                    this.selectItemArr = [];
                } else {
                    this.selectItemArr = this.quickClouds;
                }
            } else {
                if (this.selectItemArr.length && this.selectItemArr.length == this.normalClouds.length) {
                    this.selectItemArr = [];
                } else {
                    this.selectItemArr = this.normalClouds;
                }
            }
        },
        submitValue() {//提交数据进行搜索
            let that = this;
            this.resultArr = [];
            if (this.selectItemArr.length && this.searchValue) {
                this.searchDialogShow = false;
                this.$parent.searching = true;
                for (let i = 0; i < this.selectItemArr.length; i++) {//分别对每条数据进行搜索
                    let searchData = new cloudExploerUtils.fileSearchData(JSON.parse(localStorage.getItem("user")).id, that.selectItemArr[i].id, this.searchValue);
                    that.Utils.doFilesRequest('search', searchData).then(result => {
                        if (result.status == 200) {//对返回的数据进行封装
                            $.each(result.items, function (index, itemData) {
                                itemData.driveId = result.driveId;
                                itemData.driveType = that.selectItemArr[i].driveType;
                                itemData.rootId = that.selectItemArr[i].rootId;
                                itemData.rootName = that.selectItemArr[i].name;
                                if(!that.resultArr.length){
                                that.$router.push({
                                    name: "cloudExploer",
                                    query: {
                                        searchResult: 1111
                                    }
                                }); 
                                }
                                that.resultArr.push(itemData);
                            });
                            if (i == that.selectItemArr.length - 1) {//提交数据
                                that.searchDialogShow = false;
                                that.$parent.searching = false;
                                if(that.$route.query.searchResult=='1111'){
                                 that.$parent.searchResultShow = true;
                                 that.$parent.selectItemArr = [];
                                 that.$parent.tableData = [];
                                 }
                            }
                        }
                    });
                }
            }
        },
        changeColor() {
            let element = document.getElementsByClassName("search-type-input");
            element[0].style.color = "#000";
        },
        handleClose(e) {
            this.searchDialogShow = false;
        }
    }
};
</script>

<style>
.searchSubmit {
    position: relative;
    left: -10Px;
    top: 10Px;
    float: right;
}

.search-type-input {
    width: 285px;
    /*no*/
    margin-left: 10px;
    /*no*/
    height: 30px;
    /*no*/
}

.choose-search-type {
    width: 380px;
    /*no*/
    height: 310px;
    /*no*/
    border: 1px solid #8a96e3;
    /*no*/
    position: relative;
    right: 380Px;
    top: 25px;
    /*no*/
    background-color: #fff;
    box-sizing: border-box;
    z-index: 3;

}

.search-type-des {
    width: 350px;
    /*no*/
    margin-left: 10px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
    /*no*/
    height: 40px;
    /*no*/
    line-height: 50px;
    /*no*/
    float: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.choose-all {
    margin-left: 10px;
    /*no*/
    width: 358px;
    /*no*/
    height: 160px;
    /*no*/
    border: 1px solid #e4e9f3;
    /*no*/
    float: left;
}

.choose-title {
    height: 30px;
    /*no*/
    border-bottom: 1px solid #e4e9f3;
    /*no*/
    box-sizing: border-box;
    padding-left: 10px;
    /*no*/
    line-height: 30px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
    /*no*/
}

.choose-items {
    height: 130px;
    /*no*/
    width: 100%;
    /*no*/
    overflow: auto;
    box-sizing: border-box;
    padding-left: 10px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
}

.choose-items::-webkit-scrollbar {
    width: 6px;
    /*no*/
    height: 6px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #fff;
    /*背景颜色*/
}

.choose-items::-webkit-scrollbar-thumb {
    height: 1px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

.choose-item {
    width: 100%;
    height: 28px;
    /*no*/
}

.choose-cloud {
    width: 315Px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 5Px;
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_exploer_popups/search_popup.vue